import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { MapPinX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageHeading, PageHeadingBackButton, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import FuturesClientCategorisationLayout from '@/features/futures/layouts/client-categorisation';

const FuturesClientCategorisationJurisdictionUnavailablePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <FuturesClientCategorisationLayout className="-md:justify-center" size="sm">
      <div className="flex flex-col relative space-y-8">
        <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
          <MapPinX />
        </GradientIcon>
        <PageHeading centered>
          <PageHeadingTitle className="mb-8">{t('FuturesAppropriatenessClientCategorisation.jurisdictionUnavailable.title')}</PageHeadingTitle>
          <PageHeadingDescription className="whitespace-pre-line">{t('FuturesAppropriatenessClientCategorisation.jurisdictionUnavailable.description')}</PageHeadingDescription>
        </PageHeading>
        <PageHeadingBackButton
          className="order-first self-start -md:!mb-0 md:!mb-8 xl:mb-0 !mt-0"
          onClick={() => navigate('/futures/client-categorisation', { replace: true })}
          floatingInPage="left"
          fixedInLayout
        />
        <Button size="lg" variant="primary" asChild>
          <a href={import.meta.env.VITE_APP_EXCHANGE_URL}>{t('buttons.exchange')}</a>
        </Button>
      </div>
    </FuturesClientCategorisationLayout>
  );
};
FuturesClientCategorisationJurisdictionUnavailablePage.displayName = 'FuturesClientCategorisationJurisdictionUnavailablePage';

export default FuturesClientCategorisationJurisdictionUnavailablePage;
